/*
  Marlas cart improvements - Oct 21 2026.
  - Delivery estimate matches checkout: Standard arrives by +9 business days, Express by +6; each needs 2 days before the event, otherwise 'text us'. Jessica Angel / Atria 4-6 weeks. Oct 23: tap-to-open calendar with icon.
  - Saves the event date to the cart as soon as it is picked (the theme only saved it on checkout).
  - Phone-size cart page: total + Secure checkout bar pinned to the bottom while scrolling.
*/
(function () {
  if (window.__marlasCart) return;
  window.__marlasCart = true;

  // Oct 23 2026: matches the checkout shipping options exactly.
  // Standard (5-9 business days, Tanya Oct 23) / Express "need it sooner" (4-6 business days).
  var STANDARD_BUSINESS_DAYS = 9;   // latest standard arrival = the "arrives by" date
  var EXPRESS_BUSINESS_DAYS = 6;    // latest express arrival
  var EVENT_BUFFER_DAYS = 2;        // dress should land at least 2 days before the event
  var MADE_TO_ORDER_DAYS = [28, 42];
  var SMS = 'sms:+14165362956';

  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }
  function addDays(start, n) {
    var d = new Date(start.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  function parseDate(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
  }
  function scopeOf(el) {
    return (el && (el.closest('cart-drawer') || el.closest('.main-cart'))) || document;
  }

  function fmtLong(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function daysBetween(a, b) {
    return Math.round((b - a) / 86400000);
  }

  function updateEta(box) {
    var scope = scopeOf(box);
    var input = scope.querySelector('input[name="attributes[date]"]');
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var slow = box.getAttribute('data-slow') === 'true';
    var ev = input ? parseDate(input.value) : null;
    var html;

    // Friendly, solution-first wording: never tell a shopper "it won't arrive".
    box.classList.remove('marlas-eta--tip');
    if (ev && ev < today) {
      box.classList.add('marlas-eta--tip');
      box.innerHTML = '<strong>That date has already passed.</strong> Please check your event date so we can make sure your dress arrives in time.';
      return;
    }
    if (slow) {
      var from = addDays(today, MADE_TO_ORDER_DAYS[0]);
      var to = addDays(today, MADE_TO_ORDER_DAYS[1]);
      var range = fmt(from) + ' – ' + fmt(to);
      if (!ev) {
        html = '<strong>Made to order by the designer:</strong> arrives about ' + range + '.';
      } else if (ev >= addDays(to, EVENT_BUFFER_DAYS)) {
        html = '<strong>Made to order by the designer:</strong> arrives about ' + range + ', in time for your event on ' + fmt(ev) + '.';
      } else {
        box.classList.add('marlas-eta--tip');
        html = '<strong>This designer makes each dress to order</strong> (about ' + range + '). For your ' + fmt(ev) + ' event, <a href="' + SMS + '">text us</a> and we’ll check stock or suggest similar styles that arrive in time.';
      }
      box.innerHTML = html;
      return;
    }

    var stdBy = addBusinessDays(today, STANDARD_BUSINESS_DAYS);
    var expBy = addBusinessDays(today, EXPRESS_BUSINESS_DAYS);
    if (!ev) {
      html = '<strong>Arrives by ' + fmtLong(stdBy) + '.</strong> In a hurry? Choose Express at checkout and it arrives by ' + fmtLong(expBy) + '.';
    } else if (ev >= addDays(stdBy, EVENT_BUFFER_DAYS)) {
      html = '<strong>&#10003; Arrives by ' + fmtLong(stdBy) + '</strong>, ' + daysBetween(stdBy, ev) + ' days before your event on ' + fmt(ev) + '.';
    } else if (ev >= addDays(expBy, EVENT_BUFFER_DAYS)) {
      box.classList.add('marlas-eta--tip');
      html = '<strong>Choose Express at checkout</strong> and your dress arrives by ' + fmtLong(expBy) + ', ' + daysBetween(expBy, ev) + ' days before your event on ' + fmt(ev) + '.';
    } else {
      box.classList.add('marlas-eta--tip');
      html = '<strong>Your event is on ' + fmtLong(ev) + '. We can usually make it happen.</strong> <a href="' + SMS + '">Text us</a> before ordering and we’ll confirm the fastest option.';
    }
    box.innerHTML = html;
  }

  // Tap anywhere on the date box to open the calendar (phones show no icon of their own).
  document.addEventListener('click', function (event) {
    var wrap = event.target.closest && event.target.closest('.marlas-event-card__date');
    if (!wrap) return;
    var input = wrap.querySelector('input[name="attributes[date]"]');
    if (!input || event.target === input) return;
    try { if (input.showPicker) { input.showPicker(); return; } } catch (e) {}
    input.focus();
  });
  function markEmpty() {
    document.querySelectorAll('.marlas-event-card__date').forEach(function (w) {
      var i = w.querySelector('input[name="attributes[date]"]');
      w.classList.toggle('is-empty', !(i && i.value));
    });
  }
  document.addEventListener('input', markEmpty);
  document.addEventListener('change', markEmpty);
  document.addEventListener('DOMContentLoaded', markEmpty);

  // Saves run one after another so the latest date always wins.
  var saving = Promise.resolve();
  function saveEventDate(value) {
    saving = saving.then(function () {
      return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { date: value } }),
        keepalive: true
      });
    }).catch(function () {});
  }

  function realCheckoutButton() {
    return document.querySelector('.main-cart button[name="checkout"]');
  }

  function updateSticky() {
    var bar = document.querySelector('[data-marlas-sticky]');
    if (!bar) return;
    var btn = realCheckoutButton();
    if (!btn) {
      bar.classList.remove('is-visible');
      return;
    }
    var r = btn.getBoundingClientRect();
    var onScreen = r.top < window.innerHeight && r.bottom > 0;
    bar.classList.toggle('is-visible', !onScreen);
  }

  // The calendar only offers today onwards.
  function setMinDates() {
    var t = new Date();
    var iso = t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0');
    document.querySelectorAll('input[name="attributes[date]"]').forEach(function (i) {
      if (i.getAttribute('min') !== iso) i.setAttribute('min', iso);
    });
  }

  function updateAll() {
    setMinDates();
    markEmpty();
    document.querySelectorAll('[data-marlas-eta]').forEach(updateEta);
    updateSticky();
  }

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (t && t.name === 'attributes[date]') {
      saveEventDate(t.value);
      scopeOf(t).querySelectorAll('[data-marlas-eta]').forEach(updateEta);
    }
  });
  document.addEventListener('input', function (event) {
    var t = event.target;
    if (t && t.name === 'attributes[date]') {
      scopeOf(t).querySelectorAll('[data-marlas-eta]').forEach(updateEta);
    }
  });

  document.addEventListener('click', function (event) {
    var sticky = event.target.closest && event.target.closest('[data-marlas-sticky-checkout]');
    if (!sticky) return;
    // Nov 3 2026: no tick box any more; the sticky bar goes straight to checkout.
    event.preventDefault();
    var btn = realCheckoutButton();
    var form = btn && btn.form;
    if (form && form.requestSubmit) { form.requestSubmit(btn); return; }
    if (btn) { btn.click(); return; }
    window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout';
  });

  // Signature Garment Bag add-on: one tap to add or remove, then refresh the cart.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-marlas-bag-toggle]');
    if (!btn) return;
    var card = btn.closest('[data-marlas-bag]');
    if (!card || card.classList.contains('is-busy')) return;
    card.classList.add('is-busy');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var added = card.classList.contains('is-added');
    var req = added
      ? fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: card.getAttribute('data-line-key'), quantity: 0 }) })
      : fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(card.getAttribute('data-variant-id')), quantity: 1 }] }) });
    req.then(function () {
      if (card.closest('.main-cart')) {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        card.classList.remove('is-busy');
      }
    }).catch(function () {
      card.classList.remove('is-busy');
    });
  });

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      updateSticky();
    });
  }, { passive: true });
  window.addEventListener('resize', updateSticky);

  // Cart contents re-render after quantity changes; refill any empty estimate.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      var empty = false;
      document.querySelectorAll('[data-marlas-eta]').forEach(function (b) { if (!b.innerHTML) empty = true; });
      if (empty) updateAll(); else updateSticky();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('cart-drawer:refreshed', updateAll);
  window.addEventListener('pageshow', updateAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
